module.exports = __webpack_public_path__ + "img/empty.16f66fa1.png";